import Wrapper from "./Wrapper";

const PrivacyPolicy = () => {
  return (
    <Wrapper seoTitle="Privacy Policy">
      <div className="content_inner">
        <h4>Overview</h4>
        <p>
          Welcome to the Website of "KalistaJewels". KalistaJewels respects your
          privacy and is very important to us. We do not sell or rent your
          personal information to third parties for their marketing purposes
          without your explicit consent. Please read this privacy policy to
          learn more about the ways in which we use and protect your personal
          information. The privacy practices of this statement apply to our
          services available under the domain name KalistaJewels.co.in (the
          "Site"). By visiting this website you agree to be bound by the terms
          and conditions of this Privacy Policy. If you do not agree please do
          not use or access our Site.
        </p>
        <p>
          This Privacy Policy describes the information, as part of the normal
          operation of our services; we collect from you and what may happen to
          that information. By accepting the Privacy Policy and the User
          Agreement in registration, you expressly consent to our use and
          disclosure of your personal information in accordance with this
          Privacy Policy. This Privacy Policy is incorporated into and subject
          to the terms of the User Agreement. This Privacy Policy is effective
          upon acceptance in registration for new registering users, and is
          otherwise effective for all users. This Privacy Policy is updated from
          time to time; therefore, it should be reviewed occasionally.
        </p>
        <h4>Your Privacy - Our Commitment</h4>
        <p>
          At KalistaJewels Online, we are extremely proud of our commitment to
          protect your privacy. We value your trust in us. We will work hard to
          earn your confidence so that you can enthusiastically use our services
          and recommend us to friends and family. Please read the following
          policy to understand how your personal information will be treated as
          you make full use of our Site.
        </p>
        <h4>Privacy Guarantee</h4>
        <p>
          KalistaJewels Online promises that we will not sell or rent your
          personal information to third parties for their marketing purposes
          without your explicit consent. Your trust and confidence are our
          highest priority.
        </p>
        <h4>Information We Collect</h4>
        <p>
          When you use our Site, we collect and store your personal information
          from you. Our primary goal in doing so is to provide a safe,
          efficient, smooth and customized experience. This allows us to provide
          services and features that most likely meet your needs, and to
          customize our Site to make your experience safer and easier.
          Importantly, we only collect personal information about you that we
          consider necessary for achieving this purpose.
        </p>
        <p>
          In general, you can browse the Site without telling us who you are or
          revealing any personal information about yourself. Once you give us
          your personal information, you are not anonymous to us. To fully use
          our Site, you will need to register using our online registration
          form, where you may be required to provide us with your contact and
          identity information, residence / place of business information,
          billing information, shipping information and other personal
          information as indicated on the forms throughout the Site. Where
          possible, we indicate which fields are required and which fields are
          optional. You always have the option to not provide information by
          choosing not to use a particular service or feature on the Site.
        </p>
        <p>
          Data in relation to credit card payments is processed by "Bank of
          India" on a secure website linked to ours and they have their own
          privacy policy.
        </p>
        <h4>Cookies Usage</h4>
        <p>
          We use data collection devices such as "cookies" on certain pages of
          the Site to help analyze our web page flow, measure promotional
          effectiveness, and promote trust and safety. "Cookies" are small files
          placed on your hard drive that assist us in providing our services. We
          offer certain features that are only available through the use of a
          "cookie". We also use cookies to allow you to enter your password less
          frequently during a session. Cookies can also help us provide
          information that is targeted to your interests. Most cookies are
          "session cookies," meaning that they are automatically deleted from
          your hard drive at the end of a session. You are always free to
          decline our cookies if your browser permits, although in that case you
          may not be able to use certain features on the Site and you may be
          required to reenter your password more frequently during a session.
        </p>
        <p>
          Additionally, you may encounter "cookies" or other similar devices on
          certain pages of the Site that are placed by third parties. For
          example, if you view a web page created by a user, there may be a
          "cookie" placed within that web page. We do not control the use of
          cookies by third parties.
        </p>
        <h4>Our use of your Information</h4>
        <p>
          We may share personal information with our other corporate entities
          and affiliates to: help detect and prevent identity theft, fraud and
          other potentially illegal acts; correlate related or multiple accounts
          to prevent abuse of our services; and to facilitate joint or
          co-branded services that you request where such services are provided
          by more than one corporate entity. Those entities and affiliates may
          not market to you as a result of such sharing unless you explicitly
          opt-in. We may disclose personal information if required to do so by
          law or in the good faith belief that such disclosure is reasonably
          necessary to respond to court orders, or other legal process. We may
          disclose personal information to law enforcement offices, third party
          rights owners, or others in the good faith belief that such disclosure
          is reasonably necessary to: enforce our Terms or Privacy Policy;
          respond to claims that an advertisement, posting or other content
          violates the rights of a third party; or protect the rights, property
          or personal safety of our users or the general public.
          KalistaJewels.co.in and its affiliates will share some or all of your
          personal information with another business entity in case of plan to
          merge with, or be acquired by that business entity.
        </p>
        <h4>Third Party Links</h4>
        <p>
          Third party links may be discovered on our site. These third party
          links have their own privacy policy, which you agree to when you click
          on the link. We are not responsible nor do we accept responsibility
          for third party links. Our liability covers us only on our site, and
          thus we do not accept liability for third party links as we have no
          control over them.
        </p>
        <h4>Contacting Us</h4>
        <p>
          Please feel free to contact us with queries, requests, or comments you
          may have about our Privacy Policy. We welcome any communication via
          the email address supplied here: info@KalistaJewels.com If you want to
          remove your contact information from KalistaJewels.com lists and
          newsletters, please call at our customer care (10am - 6pm IST, Monday
          - Friday).
        </p>
      </div>
    </Wrapper>
  );
};

export default PrivacyPolicy;
